import { axios } from '@/plugins/axios';
import { Statement } from "@/helpers/Interfaces";

export default class RegisterTasksService
{
    public static async deleteDocument(publicId: string): Promise<Statement>
    {
        return (await axios.post(`office/document/${publicId}/delete`)).data;
    }

    public static async changeModule(publicId: string, moduleId: number): Promise<Statement>
    {
        return (await axios.post(`office/document/${publicId}/change-module/${moduleId}`)).data;
    }
}
